<script setup lang="ts">
import Avatar from '@/shared/components/Avatar/Avatar.vue'
import { useCallNotifications, removeCallNotification } from './callNotifications'

const state = useCallNotifications()
</script>

<template>
  <div class="callNotifs">
    <transition-group name="cn">
      <div
        v-for="n in state.items"
        :key="n.id"
        class="callNotif"
        @click="removeCallNotification(n.id)"
      >
        <div class="callNotif__avatar">
          <Avatar
            :width="40"
            :height="40"
            :user="n.user"
          />
        </div>
        <div class="callNotif__body">
          <div class="callNotif__title">{{ n.title }}</div>
          <div class="callNotif__text">{{ n.text }}</div>
        </div>
        <svg
          class="callNotif__icon"
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M4 6.5A2.5 2.5 0 0 1 6.5 4h11A2.5 2.5 0 0 1 20 6.5v7A2.5 2.5 0 0 1 17.5 16H10l-4.5 4v-4H6.5A2.5 2.5 0 0 1 4 13.5z"
            stroke="currentColor"
            stroke-width="1.7"
            stroke-linejoin="round"
          />
        </svg>
      </div>
    </transition-group>
  </div>
</template>

<style scoped>
.callNotifs {
  position: fixed;
  top: 18px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 100001;
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: min(380px, calc(100vw - 24px));
  pointer-events: none;
}
.callNotif {
  pointer-events: auto;
  display: flex;
  align-items: center;
  gap: 10px;
  background: rgba(28, 30, 38, 0.92);
  backdrop-filter: blur(8px);
  color: #fff;
  border-radius: 14px;
  padding: 10px 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.35);
  cursor: pointer;
}
.callNotif__avatar { flex: 0 0 40px; }
.callNotif__body { flex: 1; min-width: 0; }
.callNotif__title {
  font-family: var(--font-family-text);
  font-weight: 700;
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.callNotif__text {
  font-family: var(--font-family-text);
  font-size: 13px;
  opacity: 0.85;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.callNotif__icon { flex: 0 0 18px; opacity: 0.7; }

.cn-enter-active, .cn-leave-active { transition: all 0.25s ease; }
.cn-enter-from { opacity: 0; transform: translateY(-12px); }
.cn-leave-to { opacity: 0; transform: translateY(-12px); }
</style>
